<app-loading *ngIf="token_id; else inputEmailMode"></app-loading>
<ng-template #inputEmailMode>
  <div class="main-wrapper">
    <div class="auth-sidebar">
      <div class="header">
        <a [routerLink]="session_info?.last_routes.new_home || '/'">
          <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
        </a>
        <h3>QR code-accessible web pages for all use cases</h3>
      </div>
    </div>
    <div class="auth-contents">
      <div class="form-contents">
        <div class="form-header">
          <a [routerLink]="session_info?.last_routes.new_home || '/'" class="d-lg-none">
            <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
          </a>
          <h2>Reset Password</h2>
          <p class="lg"><a routerLink="/auth/signin">Sign in</a></p>
        </div>
        <ng-container *ngIf="mode === 'start'; else isEnd">
          <form [formGroup]="resetpass_form" (ngSubmit)="resetPass()">
            <div class="mt-4" [class.processing]="processing">
              <div class="mb-3">
                <label class="form-label bold">Email</label>
                <input type="email" class="form-control" (keyup)="success = ''; error = ''"
                  [class.is-invalid]="(resetpass_form.get('email').hasError('email') || resetpass_form.get('email').hasError('required')) && resetpass_form.get('email').touched"
                  formControlName="email" required placeholder="john@example.com">
                <ng-container *ngIf="resetpass_form.get('email').touched">
                  <p class="input-error" *ngIf="resetpass_form.get('email').hasError('email')">
                    Email is invalid!
                  </p>
                  <p class="input-error" *ngIf="resetpass_form.get('email').hasError('required')">
                    Email is required!</p>
                </ng-container>
              </div>
              <small>Password reset instructions will be sent to your registered email address.</small>
              <div class="alert alert-danger d-flex align-items-center animated fadeIn mt-3" role="alert" *ngIf="error">
                <div class="bi bi-exclamation-circle-fill"></div>
                <div>{{error}}</div>
              </div>
              <div class="alert alert-success d-flex align-items-center animated fadeIn mt-3" role="alert"
                *ngIf="success">
                <div class="bi bi-send-check"></div>
                <div [innerHtml]="success"></div>
              </div>
              <button class="btn btn-secondary btn-block mt-5" [disabled]="processing">
                <app-inline-loader *ngIf="processing"></app-inline-loader>
                <span *ngIf="!processing">Submit</span>
              </button>
            </div>
          </form>
        </ng-container>
        <ng-template #isEnd>
          <form [formGroup]="resetpass_form" (ngSubmit)="resetPass()">
            <div class="mt-4" [class.processing]="processing">
              <app-auth-password-inputs label="New Password" [data]="resetpass_form"></app-auth-password-inputs>
              <div class="alert alert-danger d-flex align-items-center animated fadeIn mt-3" role="alert" *ngIf="error">
                <div class="bi bi-exclamation-circle-fill"></div>
                <div>{{error}}</div>
              </div>
              <div class="alert alert-success d-flex align-items-center animated fadeIn mt-3" role="alert"
                *ngIf="success">
                <div class="bi bi-check2-all"></div>
                <div [innerHtml]="success"></div>
              </div>
              <button class="btn btn-secondary btn-block mt-5" [disabled]="processing">
                <app-inline-loader *ngIf="processing"></app-inline-loader>
                <span *ngIf="!processing">Submit</span>
              </button>
            </div>
          </form>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>